import script from "./DiscountPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiscountPopup.vue?vue&type=script&setup=true&lang=ts"

import "./DiscountPopup.vue?vue&type=style&index=0&id=b9be1584&lang=scss&scoped=true"

import exportComponent from "/srv/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9be1584"]])

export default __exports__